import Register from "../components/Register";
import Login from "../components/Login";
import { useLocation, Link } from "react-router-dom";
import "../css/InitiateSession.css";

export default function InitiateSession() {
  const location = useLocation();
  const loginOrRegister = location.pathname;

  return (
    <main className="container w-75">
      <Link className="text-center d-block mt-4 mb-3" to="/">
        <span className="text-dark brand-name">
          SUPERPOWER
          <i className="bi bi-lightning-fill text-dark"></i>
        </span>
      </Link>
      <div className="row justify-content-center">
        <div className="col-lg-10 col-xl-9">
          <div className="row d-flex justify-content-evenly">
            {loginOrRegister === "/login" ? (
              <>
                <div className="col-4 col-sm-5 col-md-5 p-0 text-center initiate-session-method selected overflow-hidden">
                  <a className="">Login</a>
                </div>
                <div className="col-4 col-sm-5 col-md-5 p-0 text-center initiate-session-method unselected overflow-hidden">
                  <Link to="/register" className="text-muted">
                    Register
                  </Link>
                </div>
              </>
            ) : (
              <>
                <div className="col-4 col-sm-5 col-md-5 p-0 text-center initiate-session-method unselected overflow-hidden">
                  <Link to="/login" className="text-muted">
                    Login
                  </Link>
                </div>
                <div className="col-4 col-sm-5 col-md-5 p-0 text-center initiate-session-method selected overflow-hidden">
                  <a className="">Register</a>
                </div>
              </>
            )}
          </div>
          {loginOrRegister === "/login" && <Login />}
          {loginOrRegister === "/register" && <Register />}
          <div className="w-100 mt-2">
            <Link to="/">
              <i className="fa-solid fa-arrow-left pe-2"></i>
              Back to Home
            </Link>
          </div>
        </div>
      </div>
    </main>
  );
}
